module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-28.dd4ebbb6.png";